import * as React from 'react';
import { SVGProps } from 'react';

const IconTeamSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 5.567C8 6.782 7.183 8 6 8S4 6.782 4 5.567C4 4.352 4.214 3 6 3s2 1.352 2 2.567zM1 14c0-3.667 1.111-4.5 5-4.5 3.889 0 5 .833 5 4.5H1zm8.41-6.125c.104.032.207.065.308.101.092.016.186.024.282.024 1.184 0 2-1.218 2-2.433C12 4.352 11.786 3 10 3c-.177 0-.339.013-.486.038.455.929.486 1.934.486 2.529 0 .798-.204 1.604-.59 2.308zM15 14h-2c0-1.55-.166-3.153-1.055-4.394C14.275 9.924 15 11.037 15 14z" />
  </svg>
);
export default IconTeamSizeS;
